/**
 * Taksasi API Service
 * 
 * Service layer for Taksasi API calls
 */

import api from '../../../auth/apiClient';
import { TAKSASI_API_CONFIG } from '../apiConfig';
import {
  TaksasiListResponse,
  TaksasiDetailResponse,
  TaksasiFilters,
} from '../types';

/**
 * Service class for Taksasi API operations
 */
export class TaksasiApiService {
  /**
   * Get list of Taksasi with filters and pagination
   */
  static async getList(filters?: TaksasiFilters): Promise<TaksasiListResponse> {
    const response = await api.get<TaksasiListResponse>(
      TAKSASI_API_CONFIG.endpoints.LIST,
      { params: filters }
    );
    return response.data;
  }

  /**
   * Get detail of a specific Taksasi by ID
   */
  static async getDetail(id: string): Promise<TaksasiDetailResponse> {
    const response = await api.get<TaksasiDetailResponse>(
      TAKSASI_API_CONFIG.endpoints.DETAIL(id)
    );
    return response.data;
  }
}

export default TaksasiApiService;
